import heic2any from "heic2any";

function compressStandardImage(file: File, maxWidth: number, maxHeight: number, quality: number = 0.8): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      if (event.target?.result) {
        img.src = event.target.result as string;
      } else {
        reject(new Error("Failed to read file: result is null or undefined."));
        return;
      }
    };
    reader.onerror = () => {
      reject(new Error("Error reading file"));
    };

    img.onload = () => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      if (!ctx) {
        reject(new Error("Failed to get 2D context"));
        return;
      }
      const ratio = img.width / img.height;
      // Dont scale up images
      if (img.width < maxWidth && img.height < maxHeight) {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/jpeg", quality));
        return;
      }
      // Scale down images
      if (ratio > 1) {
        canvas.width = maxWidth;
        canvas.height = maxWidth / ratio;
      } else {
        canvas.height = maxHeight;
        canvas.width = maxHeight * ratio;
      }

      const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
      const scaledWidth = img.width * scale;
      const scaledHeight = img.height * scale;
      const offsetX = (canvas.width - scaledWidth) / 2;
      const offsetY = (canvas.height - scaledHeight) / 2;
      ctx.drawImage(img, offsetX, offsetY, scaledWidth, scaledHeight);
      // ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = () => {
      reject(new Error("Error loading image"));
    };
  });
}

function isHEIC(file: File) { // check file extension since windows returns blank mime for heic
    let x = file.type ? file.type.split('image/').pop() : file.name.split('.').pop()?.toLowerCase();
    return x === 'heic' || x === 'heif';
}

function convertHEIC(file: File, maxWidth: number, maxHeight: number, quality: number = 0.8) {
  return heic2any({
    blob: file,
    toType: "image/jpg"
  }).then(function (convertedFile) {
    return compressStandardImage(convertedFile as File, maxWidth, maxHeight, quality);
  });
}

function compressImageDataUrl(file: File, maxWidth: number, maxHeight: number, quality: number = 0.8): Promise<string> {
  if (isHEIC(file)) return convertHEIC(file, maxWidth, maxHeight, quality);
  return compressStandardImage(file, maxWidth, maxHeight, quality);
}

export default compressImageDataUrl;